// extracted by mini-css-extract-plugin
export default {"svg":"_5DzuYCw-","svg__canvas":"_5D1AHWZy","svg__content":"_5D3_dpMR"};